// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableViewMenu-primaryContentItems__KZzim{display:flex;flex-direction:column;gap:var(--size-0_5)}.TableViewMenu-footer__G37Ke{padding:var(--size-1_5) var(--size-2)}.TableViewMenu-footerPadded__gScw9{padding:var(--size-3) var(--size-2_5)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryContentItems": "TableViewMenu-primaryContentItems__KZzim",
	"footer": "TableViewMenu-footer__G37Ke",
	"footerPadded": "TableViewMenu-footerPadded__gScw9"
};
export default ___CSS_LOADER_EXPORT___;
